import { render, staticRenderFns } from "./VisualizarAnoLetivoDialog.vue?vue&type=template&id=04e8c39c"
import script from "./VisualizarAnoLetivoDialog.vue?vue&type=script&lang=js"
export * from "./VisualizarAnoLetivoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports